// Petits mots d'encouragement de Kyno (le lapin mascotte).
const CHEERS = [
  "Bravo, vous l'avez tenu jusqu'au bout !",
  "Ça, c'est du temps de famille bien investi.",
  "Ton enfant s'en souviendra plus longtemps que tu ne le crois.",
  "Régularité tenue : c'est le plus dur, et c'est fait.",
  "Un petit défi de plus, un souvenir de plus.",
  "Tu viens de créer un rituel, pas juste de cocher des cases.",
  "Les grands changements se font comme ça : par petits bouts.",
  "Vous avez tenu ensemble, et ça se voit.",
];

const DAY_CHEERS = [
  "Un jour de plus, bien joué 💛",
  "Coché ! On garde le rythme.",
  "Kyno approuve cette journée.",
  "Petit pas, vraie victoire.",
  "Encore un jour de gagné ensemble.",
];

export const cheerFor = (seed = "") => {
  const n = String(seed).split("").reduce((a, c) => a + c.charCodeAt(0), 0);
  return CHEERS[n % CHEERS.length];
};

export const randomDayCheer = () => DAY_CHEERS[Math.floor(Math.random() * DAY_CHEERS.length)];

// "Tous âges" -> 0 ; "Dès 6 ans" -> 6 ; "Dès 1 an" -> 1
export const minAgeOf = (ages = "") => {
  const m = String(ages).match(/(\d+)/);
  return m ? parseInt(m[1], 10) : 0;
};
